import { createConfigParametersRepository } from '../../../configParametersRepository';
import type { ConfigRepositoryParameters } from '../../../configParametersRepository/types';
import {
  setBuyPathParam,
  setClientIdParam,
  setMktTrackParam,
} from './customDimensions';
import { getDefaultCustomDimensions } from './defaultDimensions';
import { createRuntimeGoogleState } from './state';

export const setupAnalyticsSession = async () => {
  const { getTrackingStorageClient, getStoredParameters } =
    createConfigParametersRepository();
  const configParameters: ConfigRepositoryParameters = getStoredParameters();
  const storageClient = getTrackingStorageClient();
  setMktTrackParam();
  setBuyPathParam();
  setClientIdParam();
  await getDefaultCustomDimensions(configParameters);
  const { getPagesQueue, getTrackPageFn } = createRuntimeGoogleState();
  const trackPageFn = getTrackPageFn();
  if (trackPageFn) {
    getPagesQueue()?.forEach(
      (page) => void trackPageFn(page.page, page.options)
    );
  }
  storageClient?.setInStorage(
    'sessionStorage',
    'hasToRemoveUtmParameters',
    true
  );
};
